import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify);

export default new Vuetify({
    icons: {
        iconfont: 'mdi',
    },
    theme: {
        'application.theme--light': '#ffffff',
        themes: {
            light: {
                primary: '#1976d2',
                secondary: '#164396'
            },
        },
    },
});

